import { Component } from '@angular/core';
import { AppGlobal } from '../app.global';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-page-forbidden',
  templateUrl: './page-forbidden.component.html'
})

export class PageForbiddenComponent {

  private originUrl : any;
  private isQuickwin : any;

  constructor(private appGlobal: AppGlobal) {
    this.originUrl = this.appGlobal.getOriginUrl();
    this.isQuickwin = (environment.codeApporteur == 'QUICKWIN');
  }

}



// WEBPACK FOOTER //
// ./src/app/page-forbidden/page-forbidden.component.ts